import React from "react";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "./style.css";

export default function NewButton({
  onClick,
  noIcon,
  style,
  customText,
  disabled,
  leftIcon = undefined,
  rightIcon = undefined,
}) {
  return (
    <button
      className="NewButton"
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {leftIcon}
      {!noIcon && <AddCircleIcon />}
      <span>{customText || "Nuevo"}</span>
      {rightIcon}
    </button>
  );
}
